@if (loaderShown()) {
    <!-- Note: Overlay if focus on display to read aria label -->
    <div
        class="notification-overlay"
        [class.opaque]="loaderType() !== loaderTypes.LOADER_TYPE_IMAGE"
        role="alertdialog"
        aria-modal="true"
        i18n-aria-label="@@hermes.accessibility.loader"
        aria-label="Loading, please wait."
        tabindex="-1"
        #overlay>
        @switch (loaderType()) {
            @case (loaderTypes.LOADER_TYPE_IMAGE) {
                <div class="loader image-loader" [style.background-image]="loaderImageUrl()" aria-hidden="true"> </div>
            }
            @default {
                <h-loader-spinner class="loader" aria-hidden="true"></h-loader-spinner>
            }
        }
    </div>
}
